import { MediaText } from 'editor/src/store/design/types';

import { FontStyles } from '../types';

import defaultFontStyles from './defaultFontStyles';

export const extractTextElementFontStyles = (el: MediaText): FontStyles => ({
  underline: !!el.extra.underline,
  linethrough: !!el.extra.linethrough,
  fontFamily: el.extra.fontFamily,
  fontSize: el.extra.fontSize,
  color: el.fill,
  lineHeight: el.extra.lineHeight ?? defaultFontStyles.lineHeight,
  textAlign: el.extra.textAlign ?? defaultFontStyles.textAlign,
  direction: el.extra.direction ?? defaultFontStyles.direction,
  angle: el.r,
  letterSpacing: el.extra.letterSpacing ?? defaultFontStyles.letterSpacing,
  stroke: el.extra.stroke ?? defaultFontStyles.stroke,
  shadow: el.extra.shadow ?? defaultFontStyles.shadow,
  wrapping: el.extra.wrapping ?? defaultFontStyles.wrapping,
  curve: el.extra.curve ?? defaultFontStyles.curve,
});

export default extractTextElementFontStyles;
